<template>
  <div class="loginbody" v-loading="loading" >
    <div class="logindata">
      <div class="logintext">
        <h2>注册</h2>
      </div>
      <div class="formdata">
        <el-form ref="register" :model="form" :rules="rules" >
          <el-form-item prop="nickName">
            <el-input
              v-model="form.nickName"
              clearable
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input
              v-model="form.phone"
              clearable
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code" style="width: 400px;">
            <div style="display:flex">
                <el-input
                    v-model="form.code"
                    clearable
                    placeholder="请输入验证码"
                ></el-input>
                <el-button style="width: 220px;" class="shou" @click="getCode">{{codeText}}</el-button>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              clearable
              placeholder="请输入密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="password2">
            <el-input
              v-model="form.password2"
              clearable
              placeholder="请再次输入密码"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      
      <div class="butt">
        <el-button class="shou" @click="register">注册</el-button>
      </div>
    </div>
    
  </div>
</template>

<script>



export default {
  components:{
      
  },
  name: "register",
  data() {
    return {
      form: {
        phone: "",
        password: "",
        nickName: "",
        password2: "",
        code: "",
        account:"",
        token: "lijian",
        roleCode: "1005",
        descript:"指纹头厂测管理系统",
        customerId: 1,
      },
      checked: false,
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // { max: 10, message: "不能大于10个字符", trigger: "blur" },
        ],
        nickName: [
          { required: true, message: "请输入名称", trigger: "blur" },
          // { max: 10, message: "不能大于10个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // { max: 10, message: "不能大于10个字符", trigger: "blur" },
        ],
        password2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          // { max: 10, message: "不能大于10个字符", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          // { max: 10, message: "不能大于10个字符", trigger: "blur" },
        ],
      },
      loading: false,
      activeIndex: '2',
      open: false,
      data: '',
      serverCode: '',
      codeText: '获取验证码',
      timer: null,
      phone2: "",
    };
  },
  mounted() {
      
  },
  methods: {
    register(){
        this.$refs.register.validate(valid => {
            if(valid){
                if(this.form.code!==this.serverCode){
                    this.$message({
                        message: "请输入正确的验证码",
                        type: "error",
                        showClose: true,
                    });
                    return;
                }
                if(this.form.password!==this.form.password2){
                    this.$message({
                        message: "密码不一致",
                        type: "error",
                        showClose: true,
                    });
                    return;
                }
                if(this.form.phone!==this.phone2){
                    this.$message({
                        message: "请输入正确的手机号",
                        type: "error",
                        showClose: true,
                    });
                    return;
                }
                this.loading = true;
                this.form.account = this.form.phone;
                this.$axios.post('/device_test/insert_finger_user',this.$qs.stringify(this.form)).then(res=>{   //这里使用箭头函数的形式
                    if(res.data.code==200){
                        this.loading = false
                        this.$message({
                            message: "添加成功",
                            type: 'success',
                            showClose: true,
                        });
                        this.$router.push('/')
                    }else{
                        this.loading = false
                        this.$message({
                            message: res.data.msg,
                            type: 'error',
                            showClose: true,
                        });
                    }
                }).catch(() => {
                    this.$message({
                        message: "添加失败",
                        type: "error",
                        showClose: true,
                    });
                })
            }
        });
    },
    getCode(){
        if(this.codeText!='获取验证码'){
            return;
        }
        if(this.form.phone==null || this.form.phone==''){
            this.$message({
                message: "请输入手机号",
                type: "error",
                showClose: true,
            });
            return;
        }
        if(!(/^1[34578]\d{9}$/.test(this.form.phone))){
            this.$message({
                message: "请输入正确的手机号",
                type: "error",
                showClose: true,
            });
            return;
        }
        const _this = this;
        this.codeText = '60S后重新获取';
        var s = 60;
        this.timer = setInterval(() => {
            s--;
            _this.codeText = s + 'S后重新获取';
            if (s <= 0) {
                clearInterval(this.timer);
                _this.codeText = '获取验证码';
            }    
        }, 1000);
        this.$axios.get('/device_test/get_phone_code',{
            params:{               //将URL地址拼接参数的形式换成传入params对象的形式
                token: 'lijian',
                phone: this.form.phone
            }
        }).then(res=>{   //这里使用箭头函数的形式
            if(res.data.code==200){
                this.serverCode = res.data.data.code;
                this.phone2 = this.form.phone;
            }else{
                this.$message({
                    message: res.data.msg,
                    type: "error",
                    showClose: true,
                });
            }
        }) 
    },
  },
};
</script>

<style scoped>
.header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 60px;
        font-size: 20px;
        color: #fff;
        background-color:white;
        display: flex;
        align-items: center;
}
.el-login-btn{
  margin-right:50px;

}
.loginbody {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  background-image: url("../../assets/login2.jpeg");
  background-size: 100% 100%;
  background-position: center center;
  overflow: auto;
  background-repeat: no-repeat;
  position: fixed;
  line-height: 100%;
}

.logintext {

  margin-bottom: 20px;
  line-height: 50px;
  text-align: center;
  font-size: 30px;
  font-weight: bolder;
  color: white;
  text-shadow: 2px 2px 4px #000000;
}

.logindata {
  width: 400px;
  height: 300px;
  transform: translate(-50%);
  margin-left: 50%;
  margin-top: 150px;
}

.tool {
  display: flex;
  justify-content: space-between;
  color: #606266;
}

.butt {
  margin-top: 10px;
  text-align: center;
}

.shou {
  cursor: pointer;
  color: #606266;
}

</style>




// WEBPACK FOOTER //
// src/components/views/Register.vue